import { Provider } from './Provider';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { TrackingHandler } from '../TrackingHandler';
import { getUrlParameter } from '../../helpers/browser';
export class BrowserProvider extends Provider {
    sourceBrowser = null;
    mediumBrowser = null;
    campaignBrowser = null;
    fingerprintBrowser = null;
    referralCodeBrowser = null;
    constructor() {
        super();
        this.setAttributionByReferralCode();
        this.setAttributionByAdId() ||
            this.setAttributionByUtm() ||
            this.setAttributionBySearch() ||
            this.setAttributionByReferral();
        const trackingHandler = TrackingHandler.getInstance();
        trackingHandler.initializers.push(new Promise((resolve) => {
            FingerprintJS.load({
                monitoring: false,
            }).then(async (agent) => {
                const result = await agent.get();
                this.fingerprintBrowser = result.visitorId;
                resolve();
            }, () => resolve());
        }));
    }
    get source() {
        return this.sourceBrowser;
    }
    get medium() {
        return this.mediumBrowser;
    }
    get campaign() {
        return this.campaignBrowser;
    }
    get currentUrl() {
        return new URL(window.location.protocol + '//' + window.location.host + window.location.pathname);
    }
    get fingerprint() {
        return getUrlParameter('overrideFingerprint') || this.fingerprintBrowser;
    }
    get originDetails() {
        const originD = {};
        const params = new URLSearchParams(window.location.search);
        params.forEach((value, name) => {
            originD[name] = value;
        });
        return originD;
    }
    get referralCode() {
        return this.referralCodeBrowser;
    }
    setAttributionByAdId() {
        if (getUrlParameter('adId') == null) {
            return null;
        }
        if (getUrlParameter('utm_source') || getUrlParameter('source')) {
            this.sourceBrowser = getUrlParameter('utm_source')
                ? getUrlParameter('utm_source')
                : getUrlParameter('source');
        }
        else {
            this.sourceBrowser = 'Google';
        }
        if (getUrlParameter('utm_medium') || getUrlParameter('medium')) {
            this.mediumBrowser = getUrlParameter('utm_medium')
                ? getUrlParameter('utm_medium')
                : getUrlParameter('medium');
        }
        else {
            this.mediumBrowser = 'Paid Ads';
        }
        if (getUrlParameter('utm_campaign') || getUrlParameter('campaign')) {
            this.campaignBrowser = getUrlParameter('utm_campaign')
                ? getUrlParameter('utm_campaign')
                : getUrlParameter('campaign');
        }
        else {
            this.campaignBrowser = this.sourceBrowser + ' Paid Ads';
        }
        return true;
    }
    setAttributionByUtm() {
        const sourceUtm = getUrlParameter('utm_source') ? getUrlParameter('utm_source') : getUrlParameter('source');
        const mediumUtm = getUrlParameter('utm_medium') ? getUrlParameter('utm_medium') : getUrlParameter('medium');
        const campaignUtm = getUrlParameter('utm_campaign')
            ? getUrlParameter('utm_campaign')
            : getUrlParameter('campaign');
        if (sourceUtm != null || mediumUtm != null || campaignUtm != null) {
            this.sourceBrowser = sourceUtm || 'undefined';
            this.mediumBrowser = mediumUtm || 'undefined';
            this.campaignBrowser = campaignUtm || 'undefined';
            return true;
        }
        return null;
    }
    setAttributionBySearch() {
        const search = this.getSearchEngine(document.referrer);
        if (search != null) {
            this.sourceBrowser = search;
            this.mediumBrowser = 'organic search';
            this.campaignBrowser = 'organic search ' + search;
            return true;
        }
        return null;
    }
    getSearchEngine(referral) {
        const sEngines = ['google', 'yahoo', 'bing', 'duckduckgo', 'baidu', 'aol', 'ask', 'lycos', 'yandex'];
        for (const engine of sEngines) {
            if (referral.includes(engine)) {
                return engine;
            }
        }
        return null;
    }
    setAttributionByReferral() {
        if (!this.isReferral(document.referrer)) {
            return null;
        }
        const referrerUrl = new URL(document.referrer);
        const referrerUrlStrip = referrerUrl.origin.replace(/http(s)*:\/\/(www.)*/, '');
        this.sourceBrowser = referrerUrlStrip;
        this.mediumBrowser = 'Referral';
        this.campaignBrowser = 'Referral ' + referrerUrlStrip;
        return true;
    }
    isReferral(referral) {
        return !(referral.includes('common.crawl.zone') || referral.includes(location.hostname) || referral == '');
    }
    setAttributionByReferralCode() {
        if (getUrlParameter('referralID')) {
            this.referralCodeBrowser = getUrlParameter('referralID');
        }
    }
}
